// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-red {
  color: var(--elem-red-color);
}
.color-green {
  color: green;
}
.color-blue {
  color: var(--toolbtn-active-color);
}
.publications-list {
  height: 100%;
  text-align: center;
  text-align: -webkit-center;
  overflow-y: auto;
  padding-left: 10px;
  padding-right: 4px;
  display: flex;
  width: inherit;
}
.publications-list > .list {
  margin: 0 auto auto auto;
  padding-bottom: 10px;
  width: 100%;
}
.publications-list .publication-list-preload {
  padding: 15px;
  font-size: 20px;
}
.publications-list .publication {
  flex-direction: column;
  background: var(--bg-color);
  padding: 4px 8px;
  margin-top: 10px;
  text-align: left;
  max-width: 600px;
  border-radius: 5px;
  box-shadow: 1px 1px 1px #0000004a, 0px 0px 1px #10101075;
  background-color: var(--content-container-bgcolor);
}
.publications-list .publication .publication-header,
.publications-list .publication .publication-footer {
  display: flex;
  flex-direction: column;
  height: 55px;
  padding: 5px;
}
.publications-list .publication .published-name {
  font-size: 16px;
}
.publications-list .publication .published-time {
  color: var(--message-time-color);
}
.publications-list .publication .publication-info {
  display: flex;
  margin-bottom: 5px;
}
.publications-list .publication .publication-info .publication-info-section {
  margin: auto 0;
}
.publications-list .publication .publication-info .publication-info-section.grow-section {
  flex: 1;
  padding-left: 14px;
  overflow: hidden;
}
.publications-list .publication .publication-info .publication-info-section .publisher-name {
  font-size: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.publications-list .publication .publication-info .publication-info-section .publication-menu {
  width: 25px;
  height: 25px;
  display: inline-flex;
  color: var(--custom-textarea-color);
  cursor: pointer;
}
.publications-list .publication .publication-info .publication-info-section .publication-menu:hover {
  color: var(--toolbtn-color-hover);
}
.publications-list .publication .publication-info .publication-info-section .publication-menu i {
  margin: auto;
  font-size: 18px;
}
.publications-list .publication .publication-main {
  margin: 15px 0;
  border-radius: 10px;
}
.publications-list .publication .publication-main > div:not(:last-child) {
  margin-bottom: 10px;
}
.publications-list .publication .publication-main .title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 5px;
}
.publications-list .publication .publication-main .title a:hover {
  color: var(--bot-message-color);
}
.publications-list .publication .publication-main .info-block {
  font-size: 14px;
  color: inherit;
  white-space: pre-wrap;
}
.publications-list .publication .publication-main .geo-location-item,
.publications-list .publication .publication-main .contact-item {
  cursor: pointer;
}
.publications-list .publication .publication-footer-icons {
  display: flex;
  margin: auto 0;
}
.publications-list .publication .publication-footer-icons .icon-section {
  display: flex;
  cursor: pointer;
}
.publications-list .publication .publication-footer-icons .icon-section > * {
  margin: auto 2px;
}
.publications-list .publication .publication-footer-icons .icon-section .likes-count {
  color: var(--custom-textarea-color);
}
.publications-list .publication .publication-footer-icons .icon-section i {
  font-size: 18px;
  color: var(--icon-bgcolor);
  margin-right: 10px;
}
.publications-list .publication .publication-footer-icons .icon-section i.liked {
  font-weight: bold;
  color: var(--like-color);
}
.publications-list .publication .publication-footer-icons .icon-section:not(:last-child) {
  margin-right: 10px;
}
.publications-list .publication .publication-footer-icons .icon-section:hover {
  color: var(--font-color);
}
.publications-list .publication .publication-footer-icons .icon-section.reply-section {
  margin-left: auto;
}
.publications-list .publication .hor-line {
  display: block !important;
  margin: 4px 0px 0px 0px;
  width: 100%;
}
.pubCompactMode {
  overflow-x: hidden;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/channels/Channel.vue"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,wDAAwD;EACxD,kDAAkD;AACpD;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,OAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".color-red {\n  color: var(--elem-red-color);\n}\n.color-green {\n  color: green;\n}\n.color-blue {\n  color: var(--toolbtn-active-color);\n}\n.publications-list {\n  height: 100%;\n  text-align: center;\n  text-align: -webkit-center;\n  overflow-y: auto;\n  padding-left: 10px;\n  padding-right: 4px;\n  display: flex;\n  width: inherit;\n}\n.publications-list > .list {\n  margin: 0 auto auto auto;\n  padding-bottom: 10px;\n  width: 100%;\n}\n.publications-list .publication-list-preload {\n  padding: 15px;\n  font-size: 20px;\n}\n.publications-list .publication {\n  flex-direction: column;\n  background: var(--bg-color);\n  padding: 4px 8px;\n  margin-top: 10px;\n  text-align: left;\n  max-width: 600px;\n  border-radius: 5px;\n  box-shadow: 1px 1px 1px #0000004a, 0px 0px 1px #10101075;\n  background-color: var(--content-container-bgcolor);\n}\n.publications-list .publication .publication-header,\n.publications-list .publication .publication-footer {\n  display: flex;\n  flex-direction: column;\n  height: 55px;\n  padding: 5px;\n}\n.publications-list .publication .published-name {\n  font-size: 16px;\n}\n.publications-list .publication .published-time {\n  color: var(--message-time-color);\n}\n.publications-list .publication .publication-info {\n  display: flex;\n  margin-bottom: 5px;\n}\n.publications-list .publication .publication-info .publication-info-section {\n  margin: auto 0;\n}\n.publications-list .publication .publication-info .publication-info-section.grow-section {\n  flex: 1;\n  padding-left: 14px;\n  overflow: hidden;\n}\n.publications-list .publication .publication-info .publication-info-section .publisher-name {\n  font-size: 16px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.publications-list .publication .publication-info .publication-info-section .publication-menu {\n  width: 25px;\n  height: 25px;\n  display: inline-flex;\n  color: var(--custom-textarea-color);\n  cursor: pointer;\n}\n.publications-list .publication .publication-info .publication-info-section .publication-menu:hover {\n  color: var(--toolbtn-color-hover);\n}\n.publications-list .publication .publication-info .publication-info-section .publication-menu i {\n  margin: auto;\n  font-size: 18px;\n}\n.publications-list .publication .publication-main {\n  margin: 15px 0;\n  border-radius: 10px;\n}\n.publications-list .publication .publication-main > div:not(:last-child) {\n  margin-bottom: 10px;\n}\n.publications-list .publication .publication-main .title {\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 5px;\n}\n.publications-list .publication .publication-main .title a:hover {\n  color: var(--bot-message-color);\n}\n.publications-list .publication .publication-main .info-block {\n  font-size: 14px;\n  color: inherit;\n  white-space: pre-wrap;\n}\n.publications-list .publication .publication-main .geo-location-item,\n.publications-list .publication .publication-main .contact-item {\n  cursor: pointer;\n}\n.publications-list .publication .publication-footer-icons {\n  display: flex;\n  margin: auto 0;\n}\n.publications-list .publication .publication-footer-icons .icon-section {\n  display: flex;\n  cursor: pointer;\n}\n.publications-list .publication .publication-footer-icons .icon-section > * {\n  margin: auto 2px;\n}\n.publications-list .publication .publication-footer-icons .icon-section .likes-count {\n  color: var(--custom-textarea-color);\n}\n.publications-list .publication .publication-footer-icons .icon-section i {\n  font-size: 18px;\n  color: var(--icon-bgcolor);\n  margin-right: 10px;\n}\n.publications-list .publication .publication-footer-icons .icon-section i.liked {\n  font-weight: bold;\n  color: var(--like-color);\n}\n.publications-list .publication .publication-footer-icons .icon-section:not(:last-child) {\n  margin-right: 10px;\n}\n.publications-list .publication .publication-footer-icons .icon-section:hover {\n  color: var(--font-color);\n}\n.publications-list .publication .publication-footer-icons .icon-section.reply-section {\n  margin-left: auto;\n}\n.publications-list .publication .hor-line {\n  display: block !important;\n  margin: 4px 0px 0px 0px;\n  width: 100%;\n}\n.pubCompactMode {\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
